export const START_NEXT_REVIEW = "startNextReview";
export const startNextReview = () => ({
    type: START_NEXT_REVIEW
});

export const RETRIEVED_NEXT_REVIEW = "retrievedNextReview";
export const retrievedNextReview = (review) => ({
    type: RETRIEVED_NEXT_REVIEW,
    review
});


export const NO_NEXT_REVIEW = "noNextReview";
export const noNextReview = () => ({
    type: NO_NEXT_REVIEW
});